<template>
	<div class="press-page">
		<section>
			<h2>Press Contact</h2>
			<p>
				We are happy to answer all your questions and requests for pictures, logos, etc. via:
				<a href="mailto:press@justwatch.com">press@justwatch.com</a>
			</p>
		</section>

		<section>
			<h2>JustWatch Press Room</h2>

			<p>
				<a href="https://www.justwatch.com/us/press/tvtime-migration-tool-launch"
					>JustWatch Launches Migration Tool to Help TV Time Users Preserve Their Watch History</a
				>
			</p>
		</section>

		<section>
			<h2>JustWatch in the Press</h2>

			<p>
				<a href="https://www.nytimes.com/2021/02/24/technology/justwatch-my-pandemic-bff.html" target="blank">
					"JustWatch makes finding where shows or movies are streaming online super easy. Hallelujah."
				</a>
				<br />
				Shira Ovide, New York Times
			</p>

			<p>
				<a
					href="http://fieldguide.gizmodo.com/find-out-which-streaming-service-has-that-movie-or-tv-s-1698911502"
					target="blank"
				>
					"The easiest way to tell which streaming service has the show you want."
				</a>
				<br />
				David Nield, Gizmodo
			</p>

			<div>
				<h3>As seen on</h3>
				<img
					src="https://www.justwatch.com/company/assets/logocloud_small.png"
					alt="TechCrunch, Frankfurter Allgemeine, Product Hunt, NZZ, Spiegel Online, Bild, Die Welt"
				/>
			</div>
		</section>

		<section>
			<h2><a href="https://media.justwatch.com/press">JustWatch Media in the Press</a></h2>

			<h3>
				Keynote Conversation with JustWatch Founder and CEO, David Croyé at the Variety Entertainment Marketing
				Summit
			</h3>

			<iframe class="video" src="https://www.dailymotion.com/embed/video/x9igp6c" allowfullscreen />

			<h3>On the Good Company podcast with Michael Kassan</h3>

			<picture>
				<source type="image/webp" :srcset="podcastCoverWebp" />
				<img
					class="podcast-cover"
					:src="podcastCoverJpg"
					alt="Podcast cover image with a monochrome headshot of Michael Kassan and a smaller profile image of David Croyé"
				/>
			</picture>

			<iframe
				class="podcast"
				src="https://open.spotify.com/embed/episode/2vXha8X3Vuqd4E4EcnQPhQ"
				allowfullscreen="true"
				allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
				loading="lazy"
			/>
		</section>
	</div>
</template>

<script setup lang="ts">
const podcastCoverJpg = `/${ASSETS_DIR}/img/press/podcast-cover.jpg`;
const podcastCoverWebp = `/${ASSETS_DIR}/img/press/podcast-cover.webp`;
</script>

<style lang="scss" scoped>
.press-page {
	display: flex;
	flex-direction: column;
	gap: 16px;

	max-width: 80ch;
	padding-inline: 24px;
	margin-inline: auto;
	margin-bottom: 80px;

	&__max-width-padding {
		padding-left: 10px;
		padding-right: 10px;
		max-width: 1140px;
		margin: 0 auto;
	}

	h3 {
		margin: 0;
		margin-top: 24px;
		margin-bottom: 8px;
	}
}

.video {
	width: 100%;
	aspect-ratio: 16 / 9;
	border-radius: 12px;
}

.podcast-cover {
	border-radius: 12px;
	margin-bottom: 24px;
}

.podcast {
	border-radius: 12px;
	width: 100%;
	height: 152px;
}

iframe {
	all: unset;
}
</style>
